var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushroomAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12617 6.38272C1.81369 5.70548 1.89212 4.51409 4.62488 4.90939L9.58923 4.9094C11.0427 4.72546 12.5374 4.04466 13.9794 3.38787C16.4775 2.25003 18.8175 1.18423 20.5107 2.89875C21.5784 3.97989 22.8097 5.81299 21.0247 6.58916C18.8104 6.96705 15.3548 7.16572 11.8852 7.16572C7.97759 7.16572 4.23852 6.91343 2.38188 6.44696L2.12617 6.38272Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5821 13.4548C10.2511 14.7953 9.34394 17.4701 9.09276 17.9788C8.59633 18.9841 7.10704 22.0001 12.0713 22.0001C17.0356 22.0001 15.5464 18.9841 15.0499 17.9788C14.7987 17.4701 13.8916 14.7953 13.5606 13.4548H10.5821Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 8.12505C15.8076 8.09185 16.8063 8.04073 17.7427 7.97168C17.441 8.34058 17.0416 8.76777 16.5532 9.19673C15.8422 9.82123 14.9752 10.4205 13.9964 10.8397C14.2734 10.1541 14.533 9.25624 14.7812 8.12505Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5431 10.3237C17.0234 10.7802 16.4173 11.236 15.737 11.6356C19.1322 10.8355 21.2485 8.68147 22 7.42285C21.3553 7.56683 20.5659 7.69003 19.6751 7.79245C19.3587 8.41156 18.6002 9.39521 17.5431 10.3237Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47978 7.81575C3.55695 7.70888 2.75992 7.57792 2.14274 7.42285C2.89419 8.6815 5.01061 10.8356 8.40591 11.6357C7.72554 11.2361 7.11947 10.7802 6.59974 10.3237C5.55579 9.40677 4.8031 8.43605 4.47978 7.81575Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2158 10.869C10.1631 10.7497 10.1125 10.6276 10.0639 10.504C9.77217 9.76092 9.53428 8.9068 9.36397 8.13587C8.33687 8.10654 7.34291 8.05897 6.41771 7.99316C6.71732 8.35711 7.11071 8.77608 7.58964 9.19674C8.31737 9.83596 9.20859 10.4487 10.2158 10.869Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9105 8.16602C11.6818 8.17426 12.4614 8.17269 13.2352 8.16129C12.8721 9.72072 12.5241 10.586 12.2401 11.0018C12.1924 11.0717 12.153 11.1191 12.1231 11.1509C12.0571 11.087 11.9659 10.9748 11.8578 10.7942C11.7247 10.5718 11.5904 10.2875 11.4602 9.95583C11.2466 9.41196 11.0593 8.78022 10.9105 8.16602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushroomAlt2);
export default __webpack_public_path__ + "static/media/mushroom-alt-2.c5557b173ea387dc04d4d9ce25edb2b4.svg";
export { ForwardRef as ReactComponent };